import { jsxs, jsx } from 'react/jsx-runtime';
import 'luxon';
import 'react';
import 'styled-components';
import 'lodash';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../icons/InfinityIcon.js';
import '../../icons/ArrowUpRightBoxIcon.js';
import '../CurrencyValue/components/Value.js';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import '../../../theme/ThemedComponentWrapper.js';
import '../KpiCard/KpiCard.js';
import Skeleton from '../../atoms/Skeleton.js';
import '../PercentageValue.js';
import '../Tabs/Tabs.js';
import '../TrendValue.js';
import '../../pictograms/EthPictogram.js';
import '../../pictograms/EtherScanPictogram.js';
import '../../pictograms/DebankPictogram.js';
import '../../pictograms/ZapperPictogram.js';
import '../../pictograms/DaiPictogram.js';
import '../Modal/Modal.js';
import '@floating-ui/react';
import '../../charts/ChartKpis/ChartKpi.js';
import '../../charts/ChartJS.js';
import '../../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../XRay.js';
import 'ethereum-blockies-base64';
import Card from '../../atoms/Card/Card.js';
import Flex from '../../atoms/layout/Flex/Flex.js';
import '../../atoms/layout/Stack/Stack.js';
import '../../atoms/Table/components/Pagination/Pagination.js';
import '../../atoms/Table/Table.js';
import '../../atoms/ToggleSwitch.js';
import '../../atoms/Tooltip/components/TooltipContext.js';

function HeatmapSkeleton() {
    return (jsxs(Flex, { flexDirection: "column", gap: "xs", children: [jsx(Skeleton, { height: "3", width: "10" }), jsx(Card, { gap: "2xs", display: "flex", flexDirection: "column", children: jsx(Skeleton, { height: "10" }) })] }));
}

export { HeatmapSkeleton as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhdG1hcFNrZWxldG9uLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9tb2xlY3VsZXMvc2tlbGV0b25zL0hlYXRtYXBTa2VsZXRvbi50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU2tlbGV0b24sIEZsZXgsIENhcmQgfSBmcm9tICdAYXRvbXMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBIZWF0bWFwU2tlbGV0b24oKSB7XG4gIHJldHVybiAoXG4gICAgPEZsZXggZmxleERpcmVjdGlvbj1cImNvbHVtblwiIGdhcD1cInhzXCI+XG4gICAgICA8U2tlbGV0b24gaGVpZ2h0PVwiM1wiIHdpZHRoPVwiMTBcIiAvPlxuXG4gICAgICA8Q2FyZCBnYXA9XCIyeHNcIiBkaXNwbGF5PVwiZmxleFwiIGZsZXhEaXJlY3Rpb249XCJjb2x1bW5cIj5cbiAgICAgICAgPFNrZWxldG9uIGhlaWdodD1cIjEwXCIgLz5cbiAgICAgIDwvQ2FyZD5cbiAgICA8L0ZsZXg+XG4gICk7XG59XG4iXSwibmFtZXMiOlsiX2pzeHMiLCJfanN4Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFYyxTQUFVLGVBQWUsR0FBQTtJQUNyQyxRQUNFQSxLQUFDLElBQUksRUFBQSxFQUFDLGFBQWEsRUFBQyxRQUFRLEVBQUMsR0FBRyxFQUFDLElBQUksYUFDbkNDLEdBQUMsQ0FBQSxRQUFRLElBQUMsTUFBTSxFQUFDLEdBQUcsRUFBQyxLQUFLLEVBQUMsSUFBSSxFQUFHLENBQUEsRUFFbENBLElBQUMsSUFBSSxFQUFBLEVBQUMsR0FBRyxFQUFDLEtBQUssRUFBQyxPQUFPLEVBQUMsTUFBTSxFQUFDLGFBQWEsRUFBQyxRQUFRLEVBQ25ELFFBQUEsRUFBQUEsR0FBQSxDQUFDLFFBQVEsRUFBQSxFQUFDLE1BQU0sRUFBQyxJQUFJLEVBQUcsQ0FBQSxFQUFBLENBQ25CLENBQ0YsRUFBQSxDQUFBO0FBRVg7Ozs7In0=
